export const ALL_OPCOS = ["BFS", "BRI", "BDD", "CLC", "MLN", "GLN"] as const;
export type Opco = (typeof ALL_OPCOS)[number];

export const OPCO_ROLE_PREFIX = 'OmniLinQ.Opco.';

export function allowedOpcos(roles: string[], isSuperuser: boolean): string[] {
  if (isSuperuser) return [...ALL_OPCOS];
  const held = new Set(roles);
  return ALL_OPCOS.filter((code) => held.has(OPCO_ROLE_PREFIX + code));
}
